import { render } from "./SensorTabs.vue?vue&type=template&id=0d837c39"
import script from "./SensorTabs.vue?vue&type=script&lang=js"
export * from "./SensorTabs.vue?vue&type=script&lang=js"

import "./SensorTabs.vue?vue&type=style&index=0&id=0d837c39&lang=css"
script.render = render

export default script